import { useCallback } from 'react'
import { useAuthContext } from '../context/AuthContext'
import { useGlobalState } from 'context/GlobalStateContext'
import { User, UserGroup } from 'schema'

/**
 * within a project we want to treat users that have been unassigned from that
 * project as tho they have been deleted
 *
 * a callback that takes a {@link DeletedUser} and returns true if the given
 * user has been unassigned OR actually deleted
 */
export function useUserDeleted() {
  const { user } = useAuthContext()
  const {
    state: { projectGlobalId },
  } = useGlobalState()
  const callback = useCallback<(user: DeletedUser) => boolean>(
    ({ deleted, userGroups }) => {
      const projectUserGroupIds =
        user?.projects
          .find(({ id }) => projectGlobalId === id)
          ?.userGroups?.map(({ id }) => id) ?? []
      return (
        deleted === true ||
        userGroups?.every(({ id }) => !projectUserGroupIds.includes(id))
      )
    },
    [projectGlobalId, user?.projects]
  )
  return callback
}

export type DeletedUser = Pick<User, 'deleted'> & {
  userGroups: Pick<UserGroup, 'id'>[]
}
